module.exports = __webpack_public_path__ + "img/rightIcon.feaeb81f.png";